module.exports = __webpack_public_path__ + "media/images/gift-thanks-title-onigiri-16278d3b561f0a8b45a8c2a282a3c519.png";